module.exports = __webpack_public_path__ + "img/IA2.5d67f2c3.png";